<template>
  <div :class="$style.wrapper">
    <l-lesson2-layout
      @success="(type) => handleSuccessSpect(type)"
      @successKeys="(type) => handleSuccess(type)"
      @progress="(d) => handleProgress(d)"
      @spectrogramError="(d) => handleError(d)"
      @resetCounterError="resetCounterError"
      :pianoData="pianoData"
      :xyloData="xyloData"
      :notes="notes"
      :ready="stage === 5"
      :active="active"
      :withCounter="stage === 5"
    />

    <l-popupMessage
      :items="messages"
      @click="nextStage"
      :task="task"
    />
  </div>
</template>
<script>
/* eslint-disable no-unused-vars */
import { ref, reactive, watch } from '@vue/composition-api'

import pianoSpectrogram from '@/assets/json/imperial-march_piano.json'
import xyloSpectrogram from '@/assets/json/imperial-march_xylo.json'

import notes from '@/assets/notes/imperial-march.json'

import { pushPopup, pushHint } from '@/utils/pushPopup'

import {
 arr1, arr2, arr3, arr4, hint, task1, task2,
} from './arrs'
import { task02 } from '../../../Education1/Lesson2/step1/arrs'

export default {
  name: 'step1',
  setup(props, { emit }) {
    const stage = ref(0)
    const messages = ref([])

    const task = ref(task1)

    const active = ref(false)

    const pianoData = reactive({
      current: -1,
      disabled: false,
      success: false,
      spectrogram: pianoSpectrogram,
      spectrogramDisabled: false,
    })

    const xyloData = reactive({
      current: -1,
      disabled: true,
      success: false,
      spectrogram: xyloSpectrogram,
      currentTool: false,
      spectrogramDisabled: false,
    })

    const nextStage = (val) => {
      messages.value = []

      if (val?.key === 'xylo') {
        active.value = true
        return
      }

      if (stage.value === 0) {
        pushPopup(arr1, messages.value)
      }

      if (stage.value === 1) {
        active.value = true
      }

      if (stage.value === 2) {
        pushPopup(arr2, messages.value)
      }

      if (stage.value === 3) {
        pushPopup(arr3, messages.value)
        task.value = task2
      }

      // if (stage.value === 4) {
      //   pushHint(hint, messages.value)
      // }

      if (stage.value === 5) {
        emit('nextStep', 1)
        // pushPopup(arr4, messages.value)
      }

      if (stage.value === 6) {
        emit('nextStep', 1)
      }

      stage.value += 1
    }

    nextStage()
    const handleSuccess = (type) => {
      if (type === 'piano') {
        pianoData.disabled = true
        active.value = false
        pushPopup(task02, messages.value)
      }
      if (type === 'xylo') {
        xyloData.disabled = true
        xyloData.spectrogramDisabled = true
      }

      if (pianoData.disabled && xyloData.currentTool) nextStage()
    }

    const handleSuccessSpect = (type) => {
      if (type === 'piano') {
        pianoData.success = true
        xyloData.spectrogramDisabled = false
        pianoData.spectrogramDisabled = true
      }
      if (type === 'xylo') xyloData.success = true

      if (pianoData.success && xyloData.success) nextStage()
    }
    const handleProgress = ({ type, p }) => {
      if (type === 'piano') pianoData.current = p
      if (type === 'xylo') xyloData.current = p
    }
    let errorsCount = 0
    const resetCounterError = () => {
      errorsCount = 0
    }
    const handleError = () => {
      errorsCount += 1
      if (errorsCount > 3) {
        const mess = [{ text: 'Я решил немного помочь тебе, и подсветил место для следующей звездочки, ты заметил?' }]
        pushHint(mess, messages.value, 5000)
        errorsCount = 0
      } else {
        pushHint([{ text: 'Смотри внимательнее, это не самая яркая точка в этом столбце' }], messages.value)
      }
    }

    watch(() => pianoData, () => {
      if (pianoData.disabled) {
        xyloData.disabled = false
        xyloData.currentTool = true
      }
    }, { deep: true })

    return {
      notes,

      active,
      stage,
      messages,

      pianoData,
      xyloData,

      task,

      resetCounterError,
      nextStage,
      handleSuccess,
      handleSuccessSpect,
      handleProgress,
      handleError,
    }
  },
}
</script>
<style lang="scss" module>
.wrapper {
  background: linear-gradient(180deg, #4F4F4F 0%, #0A001E 100%);
  height: 100%;
  width: 100%;
}
.container {
  padding: 0 8rem;
  display: flex;
  height: 100%;

  & > div {
    width: 50%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center
  }
}

.top {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
